import React from 'react';

import { DraftEditorProps, StringEditor, TableColumnEditor } from '../field-widgets';
import { AggregationDraft } from 'src/feature-descriptor/feature-descriptor-editor/models';

export const TemporalChangeCountEditor = (props: DraftEditorProps<AggregationDraft>) => {
  return [
    <TableColumnEditor
      key="target_time_col"
      label="target_time_column"
      {...props}
    />,
    <TableColumnEditor
      key="source_time_col"
      label="source_time_column"
      {...props}
    />,
    <StringEditor label="lower_bound" {...props} />,
    <StringEditor label="upper_bound" {...props}  />,
    <StringEditor label="range_shift" {...props}  />,
  ];
};

export const TemporalChangeEditor = (props: DraftEditorProps<AggregationDraft>) => {
  return [
    <TableColumnEditor
      key="source_col"
      label="source_column"
      {...props}
    />,
    ...TemporalChangeCountEditor(props),
  ];
};
